import { advancedFilterConditionIsComplete } from './AdvancedFilters.utilities';
import { type AdvancedFiltersInternalState } from './types';

export const getAdvancedFiltersSelectedOptionsCount = (
  internalAdvancedFilters: AdvancedFiltersInternalState,
) =>
  Object.values(internalAdvancedFilters.conditions).filter((condition) =>
    advancedFilterConditionIsComplete(condition),
  ).length;
